<!-- Header -->
<np-header [welcomeMessage]="welcome" />

<!-- Navbar -->
<np-nav [navItems]="navigationItems"></np-nav>
<router-outlet></router-outlet>
<!-- Footer -->
<np-footer
  [contentContactName]="'SPM PLM New Capabilities'"
  [contentContactUrl]="'mailto:spm-plm-new-capabilities@chevron.com'"
  [technicalContactName]="'SPM PLM New Capabilities'"
  [technicalContactUrl]="'mailto:spm-plm-new-capabilities@chevron.com'">
</np-footer>